<template>
  <div class="workbench-page" v-loading="loading" element-loading-text="加载中">
    <div class="tab">
      <div class="tab-content">
        <div class="tab-title">工作台</div>
      </div>
    </div>
    <div class="main-container">
      <!-- 左侧主要内容区 -->
      <div class="left-content">
        <div class="left-content-container">
          <!-- 目标列表 -->
          <GoalCardListInfo
            :currentMonth="currentMonth"
            :goalList="goalList"
            :roleType="roleType"
            @changeMonth="changeMonthHandle"
            @cardClick="showOrHideModalHandle('showGoalDetail', $event)"
            @yearGoalClick="showOrHideModalHandle('showYearGoalDetailModal')"
          />
  
          <!-- 团队完成情况 -->
          <TeamGoalFinishInfo
            v-if="Number(roleType) !== 3"
            :roleType="roleType"
            :teamData="teamData"
            :teamColumns="teamColumns"
            @teamClick="showOrHideModalHandle('showFullScreenModal', $event)"
          />
  
          <!-- 推进中/长期维护/已签约 -->
          <ClueListInfo
            ref="clueListInfoRef"
            :showTeamCol="Number(roleType) === 1"
            :showFollowerCol="[1, 2].includes(Number(roleType))"
            :showAddClueBtn="true"
            @addClue="showOrHideModalHandle('showAddClue')"
            @nameClick="showOrHideModalHandle('showClueDetail', $event)"
            @followerClick="showOrHideModalHandle('showFullScreenModal', $event)"
          />
  
          <!-- 拜访次数统计 -->
          <VisitNumInfo
            v-if="[2, 3].includes(Number(roleType))"
            :showFollowerCol="Number(roleType) === 2"
            @nameClick="showOrHideModalHandle('showClueDetail', $event)"
          />
        </div>
      </div>

      <!-- 右侧待处理事项 -->
      <RightAreaContent
        ref="rightAreaContentRef"
        :roleType="roleType"
        @pendingCardClick="showOrHideModalHandle('showTransferClueApply', $event)"
        @approveClueApply="showOrHideModalHandle('showApproveClueApply', $event)"
        @poolCardClick="showOrHideModalHandle('showClueDetail', $event)"
        @viewAllClick="showOrHideModalHandle('showPublicSeaClue')"
        @transferPushHandle="transferPushHandle"
        @transferIncubateHandle="transferIncubateHandle"
        @showPublicSeaClueAssignHandle="showPublicSeaClueAssignHandle"
      />
    </div>

    <!-- 全屏弹窗遮罩层 -->
    <div v-if="modalInfo.showFullScreenModal" class="back-drop">
      <!-- 小组/个人工作台 -->
      <GroupAndPersonWorkbench
        ref="groupAndPersonWorkbenchRef"
        v-if="modalInfo.showFullScreenModal"
        :month="currentMonth"
        :groupType="currentTeamInfo.groupType || 2"
        :groupInfoId="currentTeamInfo.groupInfoId || ''"
        :workNumber="currentTeamInfo.workNumber || ''"
        :teamList="teamData"
        :memberList="teamData"
        :title="currentTeamInfo.teamName || (Number(roleType) === 1 ? ((currentClueInfo.groupName || currentTeamInfo.groupName) + '-' + (currentClueInfo.followerWorkName || currentTeamInfo.followerWorkName)) : (currentClueInfo.followerWorkName || currentTeamInfo.followerWorkName))"
        @back="showOrHideModalHandle('showFullScreenModal')"
        @cardClick="showOrHideModalHandle('showGoalDetail', $event)"
        @nameClick="showOrHideModalHandle('showClueDetail', $event)"
      />
    </div>

    <!-- 月/季度/年目标卡片详情弹窗 -->
    <CustomModal
      v-model="modalInfo.showGoalDetail"
      :title="modalInfo.modalTitle"
      width="1100px"
      :showSubmitBtn="false"
      cancelBtnText="关闭"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showGoalDetail')"
    >
      <GoalDetailList
        ref="goalDetailListRef"
        v-if="modalInfo.showGoalDetail"
        :groupInfoId="currentClueInfo.groupInfoId"
        :workNumber="currentClueInfo.workNumber"
        :period="currentGoalDetail.period"
        :month="currentGoalDetail.month"
        :saleStar="currentGoalDetail.saleStar"
      />
    </CustomModal>

    <!-- 本年目标详情弹窗 -->
    <CustomModal
      v-model="modalInfo.showYearGoalDetailModal"
      title="本年目标"
      width="870px"
      :showSubmitBtn="false"
      cancelBtnText="关闭"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showYearGoalDetailModal')"
    >
      <YearGoalDetail
        v-if="modalInfo.showYearGoalDetailModal"
        ref="yearGoalDetailRef"
        :showStaffList="Number(roleType) !== 3"
      />
    </CustomModal>
 
    <!-- 新增线索 -->
    <CustomModal
      v-model="modalInfo.showAddClue"
      title="新增线索"
      width="800px"
      :showSubmitBtn="true"
      :showCancelBtn="true"
      submitBtnText="创建"
      :modalContentNoPadding="true"
      @submitHandle="addClueSubmitHandle"
      @cancelHandle="showOrHideModalHandle('showAddClue')"
    >
      <AddClue
        ref="addClueRef"
        v-if="modalInfo.showAddClue"
        :roleType="roleType"
      />
    </CustomModal>
 
    <!-- 线索详情 -->
    <CustomModal
      v-model="modalInfo.showClueDetail"
      title="线索详情"
      :width="currentClueInfo.isPublicSea ? '600px' : '860px'"
      :showSubmitBtn="false"
      :showCancelBtn="true"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showClueDetail')"
    >
      <ClueDetail
        v-if="modalInfo.showClueDetail"
        ref="clueDetailRef"
        :roleType="roleType"
        :groupInfoId="groupInfoId"
        :workNumber="workNumber"
        :hasReceivedTask="currentClueInfo.clueReceived ? '1' : '0'"
        :instanceId="currentClueInfo.doctorStageId || ''"
        :doctorId="currentClueInfo.doctorId || ''"
        :showLeftContent="!currentClueInfo.isPublicSea"
        @updateCurrentClueInfoHandle="updateCurrentClueInfoHandle"
        @confirmHandle="showOrHideModalHandle('showClueDetail')"
      />
      <template slot="footer">
        <!-- <el-button v-if="['S030'].includes(currentClueInfo.currentStepCode)" type="primary" plain @click="transferHandle('showContinueFollow')">再次推进</el-button>
        <el-button v-if="['S040', 'S060'].includes(currentClueInfo.currentStepCode)" @click="transferHandle('showPublicsea')">转入公海</el-button>
        <el-button v-if="['S040', 'S060'].includes(currentClueInfo.currentStepCode)" @click="transferHandle('showLongTime')">转长期维护</el-button>
        <el-button v-if="['S040', 'S060'].includes(currentClueInfo.currentStepCode)" @click="transferHandle('showChangeFollower')">换跟进人</el-button> -->
        <el-button @click="showOrHideModalHandle('showClueDetail')">取消</el-button>
      </template>
    </CustomModal>

    <!-- 转线索申请 -->
    <CustomModal
      v-model="modalInfo.showTransferClueApply"
      title="转线索申请"
      width="800px"
      :showSubmitBtn="false"
      :showCancelBtn="false"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showTransferClueApply')"
    >
      <TransferClueApply ref="transferClueApplyRef" :currentClueInfo="currentClueInfo" />
      <template slot="footer">
        <el-button class="approve-btn" @click="showOrHideModalHandle('showApproveClueApply', currentClueInfo)">审核</el-button>
        <el-button @click="showOrHideModalHandle('showTransferClueApply')">取消</el-button>
      </template>
    </CustomModal>

    <!-- 审核申请 -->
    <CustomModal
      v-model="modalInfo.showApproveClueApply"
      :title="modalInfo.modalTitle || '审核申请'"
      width="600px"
      :showSubmitBtn="true"
      :showCancelBtn="true"
      :modalContentNoPadding="true"
      @submitHandle="approveHandle"
      @cancelHandle="showOrHideModalHandle('showApproveClueApply')"
    >
      <ApproveClueApply
        ref="approveClueApplyRef"
        :currentClueInfo="currentClueInfo"
      />
    </CustomModal>

    <!-- 公海线索 -->
    <CustomModal
      v-model="modalInfo.showPublicSeaClue"
      title="公海线索"
      width="1100px"
      :showSubmitBtn="false"
      :showCancelBtn="true"
      :modalContentNoPadding="true"
      @cancelHandle="showOrHideModalHandle('showPublicSeaClue')"
    >
      <PublicSeaClueList
        v-if="modalInfo.showPublicSeaClue"
        ref="publicSeaClueListRef"
        :roleType="roleType"
        @showDoctorDetailHandle="showOrHideModalHandle('showClueDetail', $event)"
        @transferPushHandle="transferPushHandle"
        @transferIncubateHandle="transferIncubateHandle"
        @showPublicSeaClueAssignHandle="showPublicSeaClueAssignHandle"
      />
    </CustomModal>

    <!-- 公海线索-由我分配 -->
    <CustomModal
      v-model="modalInfo.showPublicSeaClueAssign"
      title="请选择"
      width="500px"
      :showSubmitBtn="true"
      :showCancelBtn="true"
      :modalContentNoPadding="true"
      @submitHandle="assignSelfHandle"
      @cancelHandle="showOrHideModalHandle('showPublicSeaClueAssign')"
    >
      <PublicSeaClueAssign ref="publicSeaClueAssignRef" :currentClueInfo="currentClueInfo" />
    </CustomModal>
  </div>
</template>

<script>
import utils from '@/views/DoctorVisitLTC/utils/index'
import request from '@/utils/request'
const goalList = [
  { type: 'month', tag: '月度', name: '3星医生20名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 },
  { type: 'quarter', tag: '季度', name: '4星医生16名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 },
  { type: 'year', tag: '年度', name: '5星医生8名', finishTargetNumber: 0, targetNumber: 0, percentage: 0 }
]
export default {
  data() {
    return {
      loading: false,
      roleType: '', // 1:领导 2:小组 3:个人
      groupInfoId: '', // 登录人的所属小组id
      workNumber: '', // 登录人工号
      currentMonth: new Date().getMonth() + 1,
      currentGoalDetail: { // 当前目标详情参数
        period: '',
        month: '',
        saleStar: ''
      },
      goalList: [], // 目标列表
      // 团队目标列配置
      teamColumns: [
        { label: '团队', prop: 'teamName', minWidth: '120', align: 'left', slotName: 'teamCell' },
        { label: '3月完成情况', prop: 'monthCell', minWidth: '180', align: 'left', slotName: 'monthCell' },
        { label: '第1季度完成情况', prop: 'quarterCell', minWidth: '180', align: 'left', slotName: 'quarterCell' },
        { label: '本年度完成情况', prop: 'yearCell', minWidth: '180', align: 'left', slotName: 'yearCell' }
      ],
      currentTeamInfo: {},
      teamData: [],

      modalInfo: {
        // 弹窗标题
        modalTitle: '',
        // 目标卡片弹窗
        showGoalDetail: false,
        // 本年目标详情弹窗
        showYearGoalDetailModal: false,
        // 新增线索弹窗
        showAddClue: false,
        // 线索详情弹窗
        showClueDetail: false,
        // 转线索申请弹窗
        showTransferClueApply: false,
        // 公海线索列表弹窗
        showPublicSeaClue: false,
        // 公海线索由我分配弹窗
        showPublicSeaClueAssign: false,
        // 全屏弹窗
        showFullScreenModal: false,
      },
      currentClueInfo: {}, // 当前操作的线索信息
    }
  },
  methods: {
    changeMonthHandle(month) {
      this.currentMonth = month
      this.getGoalData()
    },

    async getRoleType() {
      try {
        const res = await request.get('/cluepool/user/role', {}, '')
        if (res.code === 200) {
          const data = res.data || {}
          this.roleType = data.roleType || 0
          this.groupInfoId = data.groupInfoId || ''
          this.workNumber = data.workNumber || 0
        } else {
          this.$message.error(res.message)
          console.error('获取角色类型失败:', res.message)
        }
      } catch (error) {
        console.error('获取角色类型失败:', res.message)
      }
    },

    // 获取目标数据
    async getGoalData() {
      const params = {
        month: this.currentMonth,
        quarter: Math.floor((this.currentMonth - 1) / 3) + 1,
        year: new Date().getFullYear()
      }
      this.loading = true
      try {
        const res = await request.get('/cluepool/pc/admin/dashboard/target/detail', params, '')
        if (res.code === 200) {
          this.getGoalCardData(res.data || {})
          this.getTeamData(res.data || {})
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 处理目标数据
    getGoalCardData (data = {}) {
      const info = {
        month: 'monthTargetStartInfo',
        quarter: 'quarterTargetStartInfo',
        year: 'yearTargetStartInfo'
      }
      this.goalList = goalList.map(item => {
        const currentItemList = data[info[item.type]] || []
        if (currentItemList.length > 0) {
          return currentItemList.map(ite => {
            return {
              ...item,
              ...ite,
              name: (ite.saleStar || 0) + '星医生' + (ite.targetNumber || 0) + '名',
              finishTargetNumber: ite.finishTargetNumber || 0,
              targetNumber: ite.targetNumber || 0,
              percentage: Math.min(100, ((ite.finishTargetNumber || 0) / (ite.targetNumber || 1)) * 100)
            }
          })
        } else {
          return []
        }
      }).flat().filter(item => item.targetNumber > 0)
    },

    // 处理团队数据
    getTeamData (data = {}) {
      const key = 'groupName'
      const teamInfo = {}
      if (data.monthTargetCompleteInfo) {
        data.monthTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            monthInfo: el
          }
        })
      }
      if (data.quarterTargetCompleteInfo) {
        data.quarterTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            quarterInfo: el
          }
        })
      }
      if (data.yearTargetCompleteInfo) {
        data.yearTargetCompleteInfo.forEach(el => {
          if (!teamInfo[el[key]]) {
            teamInfo[el[key]] = {}
          }
          teamInfo[el[key]] = {
            ...teamInfo[el[key]],
            yearInfo: el
          }
        })
      }
      this.teamColumns = (this.teamColumns || []).map(item => {
        switch (item.prop) {
          case 'teamName':
            item.label = this.roleType === 1 ? '团队名称' : '成员'
            break
          case 'monthCell':
            item.label = this.currentMonth + '月完成情况'
            break
          case 'quarterCell':
            item.label = '第' + Math.floor((this.currentMonth - 1) / 3 + 1) + '季度完成情况'
            break
          default:
            break
        }
        return item
      })
      const teamData = []
      for (const key in teamInfo) {
        const info = teamInfo[key] || {}
        // 判断月度/季度/年度的
        const groupType = (info.monthInfo || info.quarterInfo || info.yearInfo || {}).groupType || ''
        const groupInfoId = (info.monthInfo || info.quarterInfo || info.yearInfo || {}).groupInfoId || ''
        const workNumber = (info.monthInfo || info.quarterInfo || info.yearInfo || {}).workNumber || ''
        teamData.push({
          groupName: key,
          teamName: key,
          groupType,
          groupInfoId,
          workNumber,
          monthInfo: this.hasTargetStar(info.monthInfo || {}),
          quarterInfo: this.hasTargetStar(info.quarterInfo || {}),
          yearInfo: this.hasTargetStar(info.yearInfo || {})
        })
      }
      this.teamData = teamData
    },

    // 判断是否有目标(星级任务是否为0，如果为0，则不显示目标，如果有多个目标，则仅显示目标的数量大于0的目标，如果所有目标都是0，则均不显示）)
    hasTargetStar(info = {}) {
      if (Object.keys(info).length === 0) return null

      const starList = info.starList || []
      const resultStarList = starList.filter(item => item.targetNumber > 0)

      if (resultStarList.length === 0) return null
      return {
        ...info,
        starList: resultStarList
      }
    },

    // 显示或隐藏弹窗
    showOrHideModalHandle(modalName, itemInfo) {
      this.modalInfo[modalName] = !this.modalInfo[modalName]
      if (itemInfo) {
        // 如果是全屏展示小组/成员数据，则赋值当前团队信息，同时还需要赋值当前线索信息，因为有可能是从线索列表中点击跟进人触发的
        if (modalName === 'showFullScreenModal') {
          this.currentTeamInfo = { ...(itemInfo || {}) }
          // 线索列表点击跟进人时，行数据可能不含 groupInfoId，按团队名从团队完成情况数据中兜底匹配
          if (!this.currentTeamInfo.groupInfoId && this.currentTeamInfo.groupName) {
            const matchedTeam = (this.teamData || []).find(team => team.groupName === this.currentTeamInfo.groupName)
            if (matchedTeam) this.currentTeamInfo.groupInfoId = matchedTeam.groupInfoId
          }
        }
        this.currentClueInfo = itemInfo || {}
        switch (modalName) {
          // 目标卡片弹窗
          case 'showGoalDetail':
            const periodInfo = {
              month: '3',
              quarter: '2',
              year: '1'
            }
            this.modalInfo.modalTitle = itemInfo.tag + '目标完成详情'
            this.currentGoalDetail = {
              period: periodInfo[itemInfo.type] || '',
              month: this.currentMonth,
              saleStar: itemInfo.saleStar || ''
            }
            break
          case 'showApproveClueApply':
            this.modalInfo.modalTitle = '审核申请'
            break
          default:
            break
        }
      } else {
        this.modalInfo.modalTitle = ''
      }
    },

    // 更改线索跟进人/转线索等重新赋值stepCode和stepId
    updateCurrentClueInfoHandle({stepCode, stepId}) {
      this.currentClueInfo.currentStepCode = stepCode
      this.currentClueInfo.currentStepId = stepId
      // 触发 workbench 内 ClueListInfo 列表刷新
      if (this.$refs.clueListInfoRef && this.$refs.clueListInfoRef.getClueList) {
        this.$refs.clueListInfoRef.getClueList()
      }
      // 若当前全屏弹窗中的 GroupAndPersonWorkbench 已打开，同步刷新其内部 ClueListInfo
      if (this.$refs.groupAndPersonWorkbenchRef && this.$refs.groupAndPersonWorkbenchRef.refreshClueList) {
        this.$refs.groupAndPersonWorkbenchRef.refreshClueList()
      }
    },

    // 审核待处理申请
    async approveHandle() {
      if (this.$refs.approveClueApplyRef) {
        const isFinish = await this.$refs.approveClueApplyRef.submitHandle()
        console.log('isFinish', isFinish)
        if (isFinish) {
          this.showOrHideModalHandle('showApproveClueApply')
          // 如果转线索申请弹窗是打开的，则关闭
          if (this.modalInfo.showTransferClueApply) {
            this.showOrHideModalHandle('showTransferClueApply')
          }
          // 刷新待审批列表
          this.$refs.rightAreaContentRef && this.$refs.rightAreaContentRef.getPendingList()
        }
      }
    },

    // 线索详情弹窗底部按钮操作
    transferHandle(modalName) {
      this.$refs.clueDetailRef.showOrHideModalHandle(modalName)
    },

    // 转推进池
    async transferPushHandle(itemInfo) {
      const confirm = await utils.messageBoxConfirm({
        message: '转推进池后，引进专员可以进行领取'
      })
      if (confirm) {
        const isSuccess = await this.transferPublicSeaClue(itemInfo.doctorId, false)
        if (isSuccess) {
          // 获取最新的公海孵化池数据
          this.$refs.rightAreaContentRef && this.$refs.rightAreaContentRef.getPublicSeaClueList(false, 'incubate')
          this.$refs.rightAreaContentRef && this.$refs.rightAreaContentRef.getPublicSeaClueList(false, 'push')
          // 同步更新公海列表弹窗数据
          this.$refs.publicSeaClueListRef && this.$refs.publicSeaClueListRef.getTableData('incubate')
          this.$refs.publicSeaClueListRef && this.$refs.publicSeaClueListRef.getTableData('push')
          this.$message.success(`已将 ${itemInfo.doctorName} 转入推进池`)
        }
      }
    },

    // 转孵化池
    async transferIncubateHandle(itemInfo) {
      const confirm = await utils.messageBoxConfirm({
        message: '转孵化池后，引进专员不可领取'
      })
      if (confirm) {
        const isSuccess = await this.transferPublicSeaClue(itemInfo.doctorId, true)
        if (isSuccess) {
          // 获取最新的公海推进池数据
          this.$refs.rightAreaContentRef && this.$refs.rightAreaContentRef.getPublicSeaClueList(false, 'incubate')
          this.$refs.rightAreaContentRef && this.$refs.rightAreaContentRef.getPublicSeaClueList(false, 'push')
          // 同步更新公海列表弹窗数据
          this.$refs.publicSeaClueListRef && this.$refs.publicSeaClueListRef.getTableData('incubate')
          this.$refs.publicSeaClueListRef && this.$refs.publicSeaClueListRef.getTableData('push')
          this.$message.success(`已将 ${itemInfo.doctorName} 转入孵化池`)
        }
      }
    },

    // 公海推进池/孵化池相互转换
    async transferPublicSeaClue (doctorId, stopTrace = false) {
      const params = {
        doctorId,
        stopTrace
      }
      let reqSuccess = false
      try {
        this.loading = true
        const res = await request.post('/cluepool/pc/form/public/transfer', params, '')
        if (res.code === 200) {
          reqSuccess = true
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('公海孵化池与推进池之间相互转换失败', error)
      } finally {
        this.loading = false
      }
      return reqSuccess
    },

    // 显示由我分配弹窗
    showPublicSeaClueAssignHandle(itemInfo) {
      if (itemInfo) this.currentClueInfo = itemInfo
      this.showOrHideModalHandle('showPublicSeaClueAssign')
    },

    // 由我分配弹窗提交
    async assignSelfHandle() {
      if (this.$refs.publicSeaClueAssignRef.submitHandle) {
        const isFinish = await this.$refs.publicSeaClueAssignRef.submitHandle()
        if (isFinish) {
          this.showOrHideModalHandle('showPublicSeaClueAssign')
          // 获取最新的公海推进池数据
          this.$refs.rightAreaContentRef && this.$refs.rightAreaContentRef.getPublicSeaClueList(false, 'incubate')
          this.$refs.rightAreaContentRef && this.$refs.rightAreaContentRef.getPublicSeaClueList(false, 'push')
          // 同步更新公海列表弹窗数据
          this.$refs.publicSeaClueListRef && this.$refs.publicSeaClueListRef.getTableData('incubate')
          this.$refs.publicSeaClueListRef && this.$refs.publicSeaClueListRef.getTableData('push')
        }
      }
    },

    // 新增线索提交
    async addClueSubmitHandle() {
      if (this.$refs.addClueRef.submitHandle) {
        const isFinish = await this.$refs.addClueRef.submitHandle()
        if (isFinish) {
          // 校验通过，执行提交逻辑
          this.$message.success('新增线索成功')
          this.showOrHideModalHandle('showAddClue')
          // 更新线索列表
          this.$refs.clueListInfoRef.getClueList()
          // 更新公海推进池线索列表
          this.$refs.rightAreaContentRef && this.$refs.rightAreaContentRef.getPublicSeaClueList(false, 'push')
        }
      }
    }
  },
  mounted() {
    this.getRoleType()
    this.getGoalData()
  },
  components: {
    GoalCardListInfo: () => import('./components/GoalCardListInfo.vue'),
    TeamGoalFinishInfo: () => import('./components/TeamGoalFinishInfo.vue'),
    ClueListInfo: () => import('./components/ClueListInfo.vue'),
    VisitNumInfo: () => import('./components/VisitNumInfo.vue'),
    GroupAndPersonWorkbench: () => import('./components/GroupAndPersonWorkbench.vue'),
    RightAreaContent: () => import('./components/RightAreaContent.vue'),
    CustomModal: () => import('@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'),
    GoalDetailList: () => import('./components/modal/GoalDetailList.vue'),
    YearGoalDetail: () => import('./components/modal/YearGoalDetail.vue'),
    ClueDetail: () => import('./components/modal/ClueDetail.vue'),
    AddClue: () => import('./components/modal/AddClue.vue'),
    TransferClueApply: () => import('./components/modal/TransferClueApply.vue'),
    ApproveClueApply: () => import('./components/modal/ApproveClueApply.vue'),
    PublicSeaClueList: () => import('./components/modal/PublicSeaClueList.vue'),
    PublicSeaClueAssign: () => import('./components/modal/PublicSeaClueAssign.vue')
  }
}
</script>

<style scoped lang="less">
.workbench-page {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #F5F5F5;

  .tab {
    padding-right: 340px;
    height: 48px;
    line-height: 48px;
    background: #FFFFFF;
    border: 1px solid #E0E0E0;
    font-weight: 600;

    .tab-content {
      .tab-title {
        margin: 0 auto;
        padding: 0 16px;
        max-width: 1300px;
      } 
    }
  }

  .main-container {
    display: flex;
  }

  // 全屏弹窗遮罩层
  .back-drop {
    position: fixed;
    top: 48px;
    left: 0;
    width: 100%;
    height: calc(100% - 48px);
    background: #FFF;
    z-index: 999;
  }
}

// 左侧内容区
.left-content {
  flex: 1;
  background-color: #fff;
  height: calc(100vh - 102px);
  overflow-y: auto;
  
  .left-content-container {
    margin: 0 auto;
    width: 100%;
    min-width: 0;
    max-width: 1300px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}

.approve-btn {
  color: #1890FF;
  border-color: #1890FF;
}

// 响应式适配
// @media screen and (max-width: 1366px) {
//   .main-container {
//     flex-direction: column;
//   }

//   .right-sidebar {
//     width: 100%;
//   }

//   .goal-cards {
//     flex-direction: column;
//   }
// }

</style>
<style lang="less">
// 线索详情弹窗底部按钮样式优化
.el-dialog__footer {
  .el-button {
    &.is-plain {
      &:hover {
        background-color: #e8f4ff;
        border-color: #1890FF;
        color: #1890FF;
      }
    }
  }
}
</style>